import script from "./DeviceFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceFrame.vue?vue&type=script&setup=true&lang=js"

import "./DeviceFrame.vue?vue&type=style&index=0&id=14ff23f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ff23f0"]])

export default __exports__